// extracted by mini-css-extract-plugin
module.exports = {"maximum":"Maximum_maximum__JHpja"};